import {
  Breadcrumb,
  BreadcrumbItem,
  PageBreadcrumb,
  PageSection,
  PageSectionVariants,
  Content,
  Icon,
  ContentVariants,
  List,
  ListItem,
} from '@patternfly/react-core';
import { ClusterIcon } from '@patternfly/react-icons';
import React from 'react';

function Privacy() {
  // @ts-ignore
  return (
    <>
      <PageBreadcrumb hasBodyWrapper={false} hasShadowBottom={false}>
        <Breadcrumb ouiaId="BasicBreadcrumb">
          <BreadcrumbItem isActive>Privacy</BreadcrumbItem>
        </Breadcrumb>
      </PageBreadcrumb>
      <PageSection hasBodyWrapper variant={PageSectionVariants.default} isWidthLimited hasShadowBottom={true}>
        <Content component="h1">
          <Icon size="lg" style={{ marginRight: '8px' }}>
            <ClusterIcon />
          </Icon>
          Privacy
        </Content>
      </PageSection>

      <PageSection hasBodyWrapper={true} variant={PageSectionVariants.default}>
        <Content isEditorial>
          <p>Last updated: Nov 1st 2024</p>
          <h2>1. Introduction</h2>
          <p>
            Welcome to Italique SRL - Ancalagon's IT Management Platform. We are committed to protecting your privacy
            and handling your data in an open and transparent manner. This privacy policy explains how we collect, use,
            share, and protect your personal information.
          </p>
          <h2>2. Information We Collect</h2>
          <h3>2.1 Client Information</h3>
          <List>
            <ListItem>Company name</ListItem>
            <ListItem>Business address</ListItem>
            <ListItem>City and postal code</ListItem>
            <ListItem>Country</ListItem>
            <ListItem>VAT Number or business identificatio number</ListItem>
            <ListItem>Business contact email</ListItem>
            <ListItem>Business phone number</ListItem>
            <ListItem>Additional business-related notes</ListItem>
          </List>
          <h3>2.2 User Information</h3>
          <List>
            <ListItem>Full name</ListItem>
            <ListItem>Email address</ListItem>
            <ListItem>Phone number (optional)</ListItem>
            <ListItem>Password (encrypted)</ListItem>
            <ListItem>Account verification status</ListItem>
            <ListItem>System access logs</ListItem>
          </List>
          <h2>3. How We Use Your Information</h2>
          <p>We use your information for the following purposes:</p>
          <List>
            <ListItem>To provide and maintain our IT management services</ListItem>
            <ListItem>To notify you about changes to our services</ListItem>
            <ListItem>To provide customer support</ListItem>
            <ListItem>To ensure the security of our system</ListItem>
            <ListItem>To comply with legal obligations</ListItem>
            <ListItem>To manage client relationships</ListItem>
          </List>
          <h2>4. Data Storage and Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information,
            including:
          </p>
          <List>
            <ListItem>Encryption of sensitive data</ListItem>
            <ListItem>Secure password storage using industry-standard hashing</ListItem>
            <ListItem>Regular security updates and maintenance</ListItem>
            <ListItem>Access controls and authentication measures</ListItem>
            <ListItem>Soft deletion practices to maintain data integrity</ListItem>
          </List>
          <h2>5. Data Retention</h2>
          <p>We retain your personal information for as long as necessary to:</p>
          <List>
            <ListItem>Provide our services</ListItem>
            <ListItem>Comply with legal obligations</ListItem>
            <ListItem>Resolve disputes</ListItem>
            <ListItem>Enforce our agreements</ListItem>
          </List>
          <p>Deleted data is soft-deleted and maintained in our system for audit purposes, with restricted access.</p>
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <List>
            <ListItem>Access your personal information</ListItem>
            <ListItem>Correct inaccurate data</ListItem>
            <ListItem>Request deletion of your data</ListItem>
            <ListItem>Object to processing of your data</ListItem>
            <ListItem>Request data portability</ListItem>
            <ListItem>Withdraw consent</ListItem>
          </List>
          <h2>7. Information Sharing</h2>
          <p>We do not sell your personal information. We may share your information with:</p>
          <List>
            <ListItem>Service providers who assist in our operations</ListItem>
            <ListItem>Legal authorities when required by law</ListItem>
            <ListItem>Third parties with your explicit consent</ListItem>
          </List>
          <h2>8. Cookies and Tracking</h2>
          <p>We use cookies and similar tracking technologies to:</p>
          <List>
            <ListItem>Maintain your session</ListItem>
            <ListItem>Enhance security</ListItem>
          </List>
          <h2>9. Changes to This Policy</h2>
          <p>We may update this privacy policy periodically. We will notify you of any material changes by:</p>
          <List>
            <ListItem>Posting the new policy on our platform</ListItem>
            <ListItem>Sending an email notification</ListItem>
            <ListItem>Displaying a notice in your dashboard</ListItem>
          </List>
          <h2>10. Contact Information</h2>
          <p>If you have questions about this privacy policy or our privacy practices, please contact us at:</p>
          <p>Email: privacy@ancalagon.be</p>
          <p>Phone: +32 483 09 91 29</p>
          <p>Address: Rue Jules Stiernet 88 - 4252 OMAL - BE</p>
          <h2>11. Legal Basis for Processing</h2>
          <p>We process your personal information based on:</p>
          <List>
            <ListItem>Contractual necessity</ListItem>
            <ListItem>Legal obligations</ListItem>
            <ListItem>Legitimate business interests</ListItem>
            <ListItem>Your consent, where required</ListItem>
          </List>
          <h2>12. International Data Transfers</h2>
          <p>
            If we transfer your data outside your country of residence, we ensure appropriate safeguards are in place
            through:
          </p>
          <List>
            <ListItem>Standard contractual clauses</ListItem>
            <ListItem>Data processing agreements</ListItem>
            <ListItem>Compliance with international data protection standards</ListItem>
          </List>
        </Content>
      </PageSection>
    </>
  );
}

export default Privacy;
